import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import './styles.css'
import { useEffect, useState } from 'react';
import { useAccessibility } from '../../../../../../Store/contexts/AccessibilityContext';
import moment from 'moment';
import { sxRadio } from './sxProps';
import TypographyAccessibility from '../../../../../../components/Accessibility/TypographyAccessibility';
import { sxLabel, sxSubtitle } from '../sxProps';
import { IHorarioDisponivel } from '../../../../../../interfaces/entities/SaudeBemEstar/PrimeiroAgendamento/HorarioDisponivel';

export interface HoursProps {
    selectedDate: Date | null,
    handleHour: (hours: IHorarioDisponivel) => void,
    selectedHour: IHorarioDisponivel | null,
    hoursList: IHorarioDisponivel[]
}

export const HoursForm = ({ selectedDate, handleHour, selectedHour, hoursList }: HoursProps) => {
    const accessibility = useAccessibility();
    const [hours, setHours] = useState<IHorarioDisponivel[]>([]);
    const [value, setValue] = useState<string>('');

    useEffect(() => {
        if (selectedDate) {
            const formattedDate = moment(selectedDate).format('DD/MM/YYYY');
            const selectedHours = hoursList.filter(hour => hour.data === formattedDate);
            setHours(selectedHours);
            setValue(
                selectedHour ? `${selectedHours.findIndex(hour => hour.hora === selectedHour.hora)}` : ''
            );
        }
    }, [selectedDate, hoursList, selectedHour]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedIndex = Number(event.target.value);
        setValue(event.target.value);
        handleHour(hours[selectedIndex]);
    };

    const getDayOfWeekName = (dayIndex: number) => {
        const dayNames = ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"];
        return dayNames[dayIndex];
    };

    return (
        <div className="hours-holder">
            {selectedDate !== null &&
                <div>
                    <TypographyAccessibility sx={sxLabel}>Horários disponíveis</TypographyAccessibility>

                    <div className="hours" style={accessibility.contrastStyle}>
                        <TypographyAccessibility sx={sxSubtitle} style={accessibility.textStyleAccessibility} >Selecione o horário para agendamento</TypographyAccessibility>
                        {hours.length > 0 &&
                            <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                name="radio-buttons-group"
                                value={value}
                                onChange={handleChange}
                            >
                                {hours.map((hour: IHorarioDisponivel, index: number) =>
                                    <FormControlLabel
                                        value={index}
                                        control={
                                            <Radio
                                                size='small'
                                                style={accessibility.textStyleAccessibility}
                                            />
                                        }
                                        label={`${hour.data} (${getDayOfWeekName(moment(hour.data, 'DD/MM/YYYY').day())}) - ${hour.hora}`} key={hour.hora} sx={sxRadio}
                                    />
                                )}
                            </RadioGroup>
                        }
                        {hours.length === 0 &&
                            <h1 className='hours-holder-message' style={accessibility.textStyleAccessibility}>Data indisponível. Selecione outra data.</h1>
                        }
                    </div>

                </div>
            }
        </div>
    )
}